import { Immutable } from "immer";
import React from "react";
import { DuplicateEmailError } from "tsi-common-react/src/forms/DuplicateEmailError/index";
import { FormErrorList } from "tsi-common-react/src/forms/FormErrorList/index";
import { ReactivatedFormWidget } from "tsi-common-react/src/forms/ReactivatedFormWidget/index";
import { FORM_FIELD_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { OrderSupportLayout } from "../OrderSupportLayout";

type IProps = Immutable<templates.RegistrationDocumentTemplate>;

export const RegistrationBody = (props: IProps): React.JSX.Element => {
    return (
        <OrderSupportLayout
            id="order-lookup"
            menuLabel="customer"
            menu={
                <ul>
                    <li>
                        <a href={props.orders_url}>{t`Orders`}</a>
                    </li>
                    <li>
                        <a href={props.support_url}>{t`Support`}</a>
                    </li>
                    <li>
                        <a href={props.financing_url}>{t`Financing`}</a>
                    </li>
                </ul>
            }
        >
            <div className="row">
                <div className="col-sm-6 register_form">
                    <form
                        id="register_form"
                        action="."
                        method="post"
                        className="form-stacked"
                    >
                        <CSRFToken />
                        {props.form.iterator.map((name) => {
                            const field = props.form.fields[name];
                            const errors = props.form.errors?.[name];
                            if (field.widget.is_hidden) {
                                // Hidden fields (e.g. username) must
                                // round-trip silently on POST — no
                                // label, wrapper, or error display.
                                return (
                                    <ReactivatedFormWidget
                                        key={name}
                                        widget={field.widget}
                                    />
                                );
                            }
                            return (
                                <div
                                    className={FORM_FIELD_CLASS_NAME}
                                    key={name}
                                >
                                    <ReactivatedFormWidget
                                        widget={field.widget}
                                    />
                                    <label htmlFor={field.widget.attrs.id}>
                                        {field.label}
                                    </label>
                                    {errors && errors.length > 0 && (
                                        <FormErrorList errors={errors} />
                                    )}
                                    {name === "email" &&
                                        props.duplicate_email && (
                                            <DuplicateEmailError
                                                loginUrl={props.login_url}
                                                resetUrl={props.reset_url}
                                            />
                                        )}
                                </div>
                            );
                        })}
                        <input
                            type="submit"
                            value={t`Register`}
                            id="register-btn"
                        />
                        {props.cancel_url && (
                            <>
                                {" "}
                                {t`or`}{" "}
                                <a href={props.cancel_url}>{t`cancel`}</a>.
                            </>
                        )}
                    </form>
                </div>
            </div>
        </OrderSupportLayout>
    );
};
